import * as effects from 'redux-saga/effects';

import { chatActions } from '../../actions';
import { getIsChatTyping } from '../../selectors';

export function* debounceChat({ payload }) {
  try {
    const isTyping = yield effects.select(getIsChatTyping);
    if (!isTyping) {
      yield effects.put(chatActions.startTyping());
    }
    if (!payload) {
      yield effects.put(chatActions.stopTyping());
    }
  } catch (e) {
    console.error(e);
  }
}
